// refactor sass to stylejs (no theme usage)
import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledFeedback = styled('div')(
  () => css`
    .feedback-component {
      box-sizing: border-box;
      z-index: 99;
      font-weight: 700;
      font-size: 0.87rem;
      line-height: 1.5rem;

      .icon {
        font-weight: normal;
      }

      .feedback-component-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 32px;
        padding: 16px 16px 0;

        &.step-header {
          padding: 20px 16px 16px;
          margin-bottom: 0;
          border-bottom: 1px solid #ccd5dc;
        }

        .header-close {
          display: none;
          margin-right: 8px;
          cursor: pointer;
        }

        .header-info {
          display: flex;
          align-items: center;
          overflow: hidden;

          .info-avatar {
            margin-right: 0 !important;
          }

          .label {
            margin-right: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .icon {
            cursor: pointer;
          }
        }
      }

      .feedback-component-body {
        &--link {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 10px 0;
          color: #6c879b;
          width: max-content;

          .icon {
            margin-left: 8px;
          }

          &:hover {
            color: #607a8d;
          }
        }

        .modal-main-actions {
          margin-bottom: 22px;
          color: #4c6fff;

          .action-item {
            display: flex;
            cursor: pointer;
            padding: 10px;
            width: max-content;

            .item-icon {
              margin-left: 16px;
              position: relative;

              .icon-flag {
                background-color: #f7936f;
                border: 2px solid #ffffff;
                border-radius: 11px;
                padding: 0 4px;
                position: absolute;
                top: -8px;
                right: -12px;
                color: #ffffff;
                font-weight: 400;
                font-size: 0.65rem;
                line-height: 0.9rem;
              }
            }

            &:hover {
              color: #2b54ff;
              .icon {
                color: #2b54ff;
              }
            }
          }
        }

        .body-ability,
        .body-support {
          padding: 0 16px 16px;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 1.5rem;
          color: #000000;

          .button--wrapper {
            margin-top: 8px;
            display: flex;
            justify-content: space-between;

            .textbox {
              .MuiOutlinedInput-multiline {
                padding: 14px;
              }
              textarea {
                font-size: 0.87rem;
              }
            }

            .MuiButton-root {
              width: 100%;
            }
          }
        }

        .body-support {
          margin-top: 24px;
        }

        .text-justify {
          text-align: justify;
        }
      }
    }
  `
);
